import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Cache busting: In dev, use timestamp so translations are never cached
// In production, use a version string you can bump when translations update
const TRANSLATION_VERSION = import.meta.env.DEV ? Date.now() : '1.0.0';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', // Shows English if Hebrew translation is missing
    debug: false, // Set to true to debug i18n issues
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'], // Persists language selection to localStorage
    },
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${TRANSLATION_VERSION}`,
    },
    react: {
      useSuspense: true, // Use Suspense for loading translations
    },
  });

export default i18n;

